module.exports = __webpack_public_path__ + "img/undraw_amusement_park_17oe.0e7307b2.svg";